// user.reducer.js
import { useReducer } from "react";
import * as ACTION from "./types";

const initialState = {
  queryHistory: [],
  queryHistoryByGroup: [],
  currentQuery: "",
  currentQueryResult: null,
  queryTasks: [],
  queryWorkflows: [],
  showModal: false,
  askMeSelectedModels: [],
  activeAgent: null,
  activeUUID: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.UPDATE_QUERY_HISTORY:
      return {
        ...state,
        queryHistory: action.payload,
      };
    case ACTION.UPDATE_GROUP_BY_QUERY_HISTORY:
      return {
        ...state,
        queryHistoryByGroup: action.payload,
      };
    case ACTION.UPDATE_CURRENT_QUERY:
      return {
        ...state,
        currentQuery: action.payload,
      };
    case ACTION.UPDATE_CURRENT_QUERY_PIPELINES:
      return {
        ...state,
        queryWorkflows: action.payload,
      };
    case ACTION.UPDATE_CURRENT_QUERY_TASKS:
      return {
        ...state,
        queryTasks: action.payload,
      };
    case ACTION.UPDATE_SHOW_MODAL:
      return {
        ...state,
        showModal: action.payload,
      };
    case ACTION.UPDATE_ASK_ME_SELECTED_MODEL:
      return {
        ...state,
        askMeSelectedModels: action.payload,
      };
    case ACTION.UPDATE_ACTIVE_AGENT:
      return {
        ...state,
        activeAgent: action.payload,
      };
    case ACTION.UPDATE_ACTIVE_UUID:
      return {
        ...state,
        activeUUID: action.payload,
      };
    case ACTION.CLEAR_ASK_ME:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

const useAIAskMeReducer = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return {
    state,
    dispatch,
  };
};

export default useAIAskMeReducer;
